import type { StoreApi } from 'zustand/vanilla';
import type { BuildDependencyGraph } from '../../../../dependency/manager/types';
import type { BuildDependencyGraphItem } from '../../../../dependency/utils/buildDependencyGraph';
import type { DataSourceControllerState } from '../types';

const getDataSourceIntraDependenciesActions = (
  set: StoreApi<DataSourceControllerState>['setState'],
) => {
  const setDataSourceIntraDependencies = ({
    dependencyGraph,
  }: {
    dependencyGraph: BuildDependencyGraph;
  }) => {
    set((state) => {
      return {
        ...state,
        dataSourceIntraDependencies: dependencyGraph,
      };
    });
  };

  const setDataSourceIntraDependenciesSingle = ({
    dependencies,
    entityId,
  }: {
    entityId: string;
    dependencies: BuildDependencyGraphItem<unknown>;
  }) => {
    set((state) => {
      return {
        ...state,
        dataSourceIntraDependencies: {
          ...state.dataSourceIntraDependencies,
          [entityId]: dependencies,
        },
      };
    });
  };

  const removeDataSourceIntraDependencies = ({ entityId }: { entityId: string }) => {
    set((state) => {
      return {
        ...state,
        dataSourceIntraDependencies: {
          ...state.dataSourceIntraDependencies,
          [entityId]: undefined,
        },
      };
    });
  };

  return {
    setDataSourceIntraDependencies,
    setDataSourceIntraDependenciesSingle,
    removeDataSourceIntraDependencies,
  };
};

export default getDataSourceIntraDependenciesActions;
